import { render } from "./WangosProjectFour.vue?vue&type=template&id=5792515e"
import script from "./WangosProjectFour.vue?vue&type=script&lang=js"
export * from "./WangosProjectFour.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__